import React from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  TextField, 
  Button, 
  Paper, 
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert
} from '@mui/material';

const ProviderSignup = () => {
  return (
    <Box sx={{ pt: 12, pb: 8, backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
      <Container maxWidth="md">
        <Paper 
          elevation={0} 
          sx={{ 
            p: 4, 
            borderRadius: '16px',
            border: '1px solid #e0e0e0',
            boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
          }}
        >
          <Typography 
            variant="h4" 
            sx={{ 
              mb: 3, 
              fontWeight: 700, 
              color: '#2C3E50',
              fontFamily: 'Ubuntu',
            }}
          >
            Registro de Profesionales
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{ 
              mb: 4, 
              color: '#666',
              lineHeight: 1.6
            }}
          >
            ¡Estamos trabajando en esta funcionalidad! Pronto podrás registrarte como profesional en Fixmigo.
          </Typography>
          
          <Alert severity="info" sx={{ mb: 4 }}>
            Esta sección estará disponible próximamente. Gracias por tu interés en formar parte de nuestra comunidad de profesionales.
          </Alert>
          
          <Button
            variant="contained"
            fullWidth
            sx={{
              bgcolor: '#FFE500',
              color: 'rgba(0,0,0,0.87)',
              py: 1.5,
              borderRadius: '8px',
              fontWeight: 600,
              '&:hover': {
                bgcolor: '#FFD700',
              },
              fontFamily: 'Ubuntu',
              textTransform: 'none',
              fontSize: '1rem',
              boxShadow: 'none'
            }}
            onClick={() => window.location.href = '/'}
          >
            Volver al Inicio
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};

export default ProviderSignup; 